'use client';
import { FadeIn } from '~/components/fade-in';

export const Header = () => {
  return (
    <FadeIn className="mx-auto my-20 max-w-5xl text-balance py-40 text-center">
      <h1 className="text-4xl md:text-6xl">
        Helping every organization unleash the full power of knowledge and artificial intelligence
      </h1>
      <p className="mt-14 md:text-2xl">
        Bringing decades of AI experience from organizations like Pytorch and Vertex AI to unlock product innovation
      </p>
    </FadeIn>
  );
};
